import { Link } from 'react-router-dom'
import { Bot, Zap, Brain, Globe, ArrowRight, Sparkles } from 'lucide-react'

export default function Home() {
  return (
    <div>
      {/* Hero */}
      <section className="relative min-h-[90vh] flex items-center justify-center px-6 overflow-hidden">
        <div className="absolute top-20 right-20 w-72 h-72 bg-primary/20 rounded-full blur-[100px] animate-pulse-glow" />
        <div className="absolute bottom-20 left-20 w-96 h-96 bg-secondary/20 rounded-full blur-[100px] animate-pulse-glow" style={{ animationDelay: '2s' }} />
        
        <div className="relative z-10 text-center max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-glass border border-glass-border mb-8">
            <Sparkles className="w-4 h-4 text-primary" />
            <span className="text-sm text-text-muted">Powered by EFEE Autopilot Technology</span>
          </div>
          
          <h1 className="text-5xl md:text-7xl font-black text-white mb-6 leading-tight">
            Your Personal<br />
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-primary to-secondary">
              AI Agent
            </span>
          </h1>
          
          <p className="text-xl text-text-muted mb-10 max-w-2xl mx-auto">
            Deploy an AI agent that runs 24/7 on autopilot. Research, create content, 
            analyze data — all while you sleep.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/register" 
              className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-primary text-dark font-bold rounded-full hover:opacity-90 transition"
            >
              Deploy Your Agent
              <ArrowRight className="w-5 h-5" />
            </Link>
            <Link 
              to="/pricing" 
              className="inline-flex items-center justify-center gap-2 px-8 py-4 border border-glass-border text-white font-semibold rounded-full hover:bg-glass transition"
            >
              View Pricing
            </Link>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="py-24 px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Why Choose <span className="text-primary">AI Agent</span>?
            </h2>
            <p className="text-text-muted max-w-2xl mx-auto">
              The first AI agent platform powered by EFEE (Effect of Finest Events) technology
              for true autonomous decision-making.
            </p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-6">
            {[
              { icon: Brain, title: 'EFEE Autopilot', desc: 'Context-aware AI that learns from your most important events and decisions.' },
              { icon: Zap, title: '24/7 Operation', desc: 'Your agent works around the clock — researching, analyzing, creating.' },
              { icon: Globe, title: 'Multi-Channel', desc: 'Deploy on Telegram, web, or integrate with your existing tools.' },
            ].map((feature, i) => (
              <div key={i} className="p-8 rounded-2xl bg-glass border border-glass-border hover:border-primary/30 transition">
                <feature.icon className="w-10 h-10 text-primary mb-4" />
                <h3 className="text-xl font-bold text-white mb-2">{feature.title}</h3>
                <p className="text-text-muted">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 px-6">
        <div className="max-w-4xl mx-auto text-center p-12 rounded-3xl bg-gradient-to-br from-primary/10 to-secondary/10 border border-glass-border">
          <Bot className="w-16 h-16 text-primary mx-auto mb-6" />
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Ready to Deploy?
          </h2>
          <p className="text-text-muted mb-8 max-w-xl mx-auto">
            Answer 8 simple questions about your goals. We'll configure and deploy 
            your AI agent in under 2 minutes.
          </p>
          <Link 
            to="/register" 
            className="inline-flex items-center gap-2 px-8 py-4 bg-primary text-dark font-bold rounded-full hover:opacity-90 transition"
          >
            Get Started Free
            <ArrowRight className="w-5 h-5" />
          </Link>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-12 px-6 border-t border-glass-border">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex items-center gap-2">
            <Bot className="w-5 h-5 text-primary" />
            <span className="font-bold text-white">AI<span className="text-primary">Agent</span></span>
          </div>
          <p className="text-text-muted text-sm">© 2026 AI Agent Portal. All rights reserved.</p>
        </div>
      </footer>
    </div>
  )
}
